import { useQuery } from "@tanstack/react-query";
import { restaurantApi } from "@/api/restaurant";

export function useRestaurant() {
  return useQuery({
    queryKey: ["restaurant"],
    queryFn: restaurantApi.getRestaurant,
  });
}
